import { ReactElement, memo } from 'react';
import { GeneratedIconProps } from '@foundation/Icon/IconProps';
/**
 * @deprecated Import Icons from `@frontify/fondue/components` instead.
 */
function IconMediaObjectTextBottom20(props: GeneratedIconProps): ReactElement<GeneratedIconProps> {
    const customClassName = 'tw-flex tw-items-center tw-justify-center tw-fill-current';
    return (
        <svg
            xmlns="http://www.w3.org/2000/svg"
            width={20}
            height={20}
            className={customClassName}
            name="IconMediaObjectTextBottom20"
            aria-hidden="true"
            {...props}
        >
            <path
                fill="currentColor"
                fillRule="evenodd"
                d="M13.5 16.75a.75.75 0 0 1-.75.75h-5.5a.75.75 0 0 1 0-1.5h5.5a.75.75 0 0 1 .75.75m2.5-3a.75.75 0 0 1-.75.75H4.75a.75.75 0 0 1 0-1.5h10.5a.75.75 0 0 1 .75.75m-.5-4.25h-11a1 1 0 0 1-1-1v-4a1 1 0 0 1 1-1h11a1 1 0 0 1 1 1v4a1 1 0 0 1-1 1m2.5-1a2.5 2.5 0 0 1-2.5 2.5h-11A2.5 2.5 0 0 1 2 8.5v-4A2.5 2.5 0 0 1 4.5 2h11A2.5 2.5 0 0 1 18 4.5z"
                clipRule="evenodd"
            />
        </svg>
    );
}
export default memo(IconMediaObjectTextBottom20);
